/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2020 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { antenatalattendancestat } from './antenatalattendancestat';
import { labordeliverystat } from './labordeliverystat';
import { patientindex } from '../domain/patientindex';
import { viralstat } from './viralstat';
import { accountingsummary } from './accountingsummary';
import { coderesult, guidelinesummary, limitandsurveyresult, resultinformation, resultsummary } from '../../services/cds/guidelinesummary';
import { alert } from '../system/alert';
import { medicationactivity } from '../ehr/subs/medicationactivity';
import { reportDataField } from '../reports/report';
import { Iceutility } from '../../services/iceutility';
import { encounterprogressnotes } from '../ehr/encounterprogressnotes';
import { encounterstat } from './encounterstat';
import { appointmentstat } from './appointmentstat';
import { clinicaldaysheetstat } from './clinicaldaysheetstat';

export class patientstat extends patientindex {
  age: number = 0.0;
  weeks: number = 0.0;
  ANTENATAL_ATTENDANCE_STAT: antenatalattendancestat[] = [];
  LABOR_DELIVERY_STAT: labordeliverystat[] = [];
  VIRAL_STAT: viralstat[] = [];
  ACCOUNTING_SUMMARY: accountingsummary[] = [];
  CDSGLDATA: guidelinesummary[] = [];
  CDSALERTSBYGL: alert[] = [];
  CDSRESULTSBYKEY: resultinformation[] = [];
  CDSRESULTS: resultsummary[] = []
  MEDACTIVITIES: medicationactivity[] = [];
  ENCSTATS: encounterstat[] = [];
  ENCNOTESTATS: encounterprogressnotes[] = [];
  APPTSTATS: appointmentstat[] = [];
  DAYSHEETSTATS: clinicaldaysheetstat[] = [];

  public gettablename(): string {
    return "PATIENT_STAT";
  }

  public hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "ANTENATAL_ATTENDANCE_STAT") return true;
    else if (ColumnName == "LABOR_DELIVERY_STAT") return true;
    else if (ColumnName == "VIRAL_STAT") return true;
    else if (ColumnName == "ACCOUNTING_SUMMARY") return true;
    else if (ColumnName == "CDSGLDATA") return true;
    else if (ColumnName == "CDSALERTSBYGL") return true;
    else if (ColumnName == "CDSRESULTSBYKEY") return true;
    else if (ColumnName == "CDSRESULTS") return true;
    else if (ColumnName == "MEDACTIVITIES") return true;
    else if (ColumnName == "ENCSTATS") return true;
    else if (ColumnName == "ENCNOTESTATS") return true;
    else if (ColumnName == "APPTSTATS") return true;
    else if (ColumnName == "DAYSHEETSTATS") return true;
    return false;
  }

  public getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "ANTENATAL_ATTENDANCE_STAT") return "ANTENATAL_ATTENDANCE_STAT";
    else if (ColumnName == "LABOR_DELIVERY_STAT") return "LABOR_DELIVERY_STAT";
    else if (ColumnName == "VIRAL_STAT") return "VIRAL_STAT";
    else if (ColumnName == "ACCOUNTING_SUMMARY") return "ACCOUNTING_SUMMARY";
    else if (ColumnName == "CDSGLDATA") return "GUIDELINE_SUMMARY";
    else if (ColumnName == "CDSALERTSBYGL") return "ALERT";
    else if (ColumnName == "CDSRESULTSBYKEY") return "RESULT_INFORMATION,CodeResult,LimitAndSurveyResult";
    else if (ColumnName == "CDSRESULTS") return "Result";
    else if (ColumnName == "MEDACTIVITIES") return "MEDICATION_ACTIVITY";
    else if (ColumnName == "ENCSTATS") return "ENCOUNTER_STAT";
    else if (ColumnName == "ENCNOTESTATS") return "ENCOUNTER_PROGRESS_NOTES";
    else if (ColumnName == "APPTSTATS") return "APPOINTMENT_STAT";
    else if (ColumnName == "DAYSHEETSTATS") return "CLINICAL_DAYSHEET_STAT";

    return null;
  }
}
